var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 16.5H3.5v4h17v-4h-1.202V15H22v7H3a1 1 0 01-.995-.898L2 21v-6h2.75v1.5zM11.75 7.114c.153-.152.355-.152.5 0l1.5 1.575c.258.265.75.788.75 1.445 0 .787-.563 1.444-1.375 1.444a1.45 1.45 0 01-.528-.104l.29 1.218a.25.25 0 01-.243.308h-1.285a.25.25 0 01-.243-.308l.287-1.206a1.486 1.486 0 01-.528.092c-.813 0-1.375-.656-1.375-1.444 0-.64.468-1.148.71-1.411l.024-.026s1.363-1.43 1.516-1.583z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 2.005a1 1 0 01.898.995v14.797l-.005.102a1 1 0 01-.893.893l-.102.005H7.25l-.103-.005a1.001 1.001 0 01-.892-.893l-.005-.102V3c0-.517.394-.944.897-.995L7.251 2h9.548l.101.005zM7.75 17.297h8.548V3.5H7.75v13.797z",
    fill: "currentColor"
  })));
}
SvgCardTable.displayName = 'CardTable';
export default SvgCardTable;